<template>
  <form
    class="search-field"
    @submit.prevent="submit"
  >
    <c-input
      v-if="isDesktop"
      icon="search"
      class="field"
      data-cy="menu-search-input"
      round
      background
      type="text"
      :value="term"
      placeholder="Qual oferta você está procurando hoje?"
      @input="input"
      @keydown.enter.native="handleAnalytics()"
    />

    <div
      class="search-field-mobile"
      v-else
    >
      <k-icon
        class="icon"
        icon="search"
        size="20"
      />
      <input
        ref="field"
        class="field"
        type="text"
        placeholder="Busque por produtos ou marcas"
        :value="term"
        @input="input"
      />
      <transition
        name="slide"
        mode="in-out"
      >
        <button
          v-if="term && term.length"
          @click.stop="$emit('reset')"
          type="button"
          class="clean"
        >
          Limpar
        </button>
      </transition>
    </div>
  </form>
</template>

<script>
import { KIcon } from 'kaledo-components'
export default {
  components: { KIcon },
  props: {
    term: {
      type: String,
      required: true
    }
  },

  mounted () {
    const focus = () => {
      const element = this.$refs.field
      if (!element) { return setTimeout(focus, 200) }
      element.focus()
    }

    focus()
  },

  methods: {
    input (event) {
      const value = this.isDesktop
        ? event
        : event.target
          ? event.target.value
          : event
      if (value.length > 2 || value.length === 0) {
        this.$emit('input', value)
      }
    },

    submit (event) {
      setTimeout(() => {
        this.$emit('submit', event)
        this.$emit('close')
      }, 500)
    },

    handleAnalytics () {
      window.dataLayer.push({
        event: 'Buscas',
        termo_buscado: this.term
      })
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.search-field {
  position: relative;
  display: flex;
  align-items: center;
  z-index: 3;
  .search-field-mobile {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    background-color: $search-input-color;
    width: 100%;
    padding: 10px;
    border-radius: 99px;
    overflow: hidden;
    input::placeholder {
      color: $disabled-font;
    }
    .icon {
      margin-right: 8.5px;
    }
    .clean {
      position: relative;
      cursor: pointer;
      z-index:1;
      background: transparent;
      border: none;
      font-size: 14px;
      color: $primary-color-placeholder;
      color: var(--color-primary);
    }
  }

  .field {
    flex: 1;
    border: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    outline: none;
    font-size: 14px;
    box-shadow: none;
    color: $title-color;
    display: inline-block;
    background-color: transparent;
    font-family: $title-font-family !important;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &::-ms-clear { display: none; }

    &::-webkit-search-cancel-button { display: none; }

    &::-webkit-search-results-button { display: none; }
  }

  & > .reset {
    position: absolute;
    right: 10px;
    background-color: grey;

    & > .icon {
      fill: $white-color;
      width: 12px !important;
      height: 12px !important;
    }
  }

  & > .icon { margin-right: 10px }

  @include desktop {
    & > .c-input-container.field {
      margin: {
        top: 15px;
        bottom: 15px;
      }

      & > .input {
        width: 400px;
        outline: none;
      }
    }
  }
  @include tablet {
    & > .c-input-container.field {
      & > .input {
        width: 300px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/SearchField.vue